export default __webpack_public_path__ + "media/images/icons_fc/doc3-cf8a537c6890dce3ac228a8ec2e82ae3.png";